var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-cnt-parent"},[_c('div',{class:['indeterminate-progress-bar', {'gop-indeterminate-progress-bar' : _vm.$route.path.includes('/gop/')}]},[_c('div',{class:['indeterminate-progress-bar__progress', {'gop-indeterminate-progress-bar__progress' : _vm.$route.path.includes('/gop/')}]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }